import { useEffect, useState } from "react";
import { useConceptoIncidencia } from "../../../hooks/GestionIncidencias/useConceptoIncidencia";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
// import { DatePickerDoble } from "../../components/pickers/DatePickerDoble";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { Modal } from "../../components/modal/Modal";
import { useModal } from "../../../hooks/useModal";
import { Tooltip } from "../../components/utils/Tooltip";
import { notify } from "../../../utils/utils";

export const IncidenciaConcepto  = () => {
    const classNameInput = "lg:w-full p-2 caret-white containerScroll text-white  rounded  bg-zinc-800 text-l focus:outline-none focus:ring-1 focus:ring-blue-500"
    const idTablaConceptoIncidencia = 'idTablaConceptoIncidencia';
    const [ codigoProducto, setCodigoProducto ] = useState(0);
    const [ isOpenModalConcepto, openModalConcepto, closeModalConcepto ] = useModal(false);
    const [ isOpenModalEliminar, openModalEliminar, closeModalEliminar ] = useModal(null);
    const calificacion = [
        {nomNivel: 'Muy leve', codNivel : 1},
        {nomNivel: 'Leve', codNivel : 2},
        {nomNivel: 'Grave', codNivel : 3},
        {nomNivel: 'Muy grave', codNivel : 4}
    ]

    const {
        listarProducto,
        producto,
        listarConceptosIncidencia,
        conceptosIncidencia,
        conceptoIncidencia,
        editarValorConceptoIncidencia,
        registrarConceptoIncidencia,
        conceptoReducer,
        eliminarConceptoIncidencia,
        editarValorEliminarConcepto,
        setDatosEliminar,
        datosEliminarDefault,
        datosEliminar
    } = useConceptoIncidencia()

    const iniciarDatosConcepto = () => {
        conceptoReducer({tipo: 'Reiniciar'});
        openModalConcepto();
    }

    const editarDatosConcepto = async (datos) => {
        await setValoresConcepto(datos)
        openModalConcepto();
    }

    const setValoresConcepto = async (datos) => {
        editarValorConceptoIncidencia('codIncidenciaConcepto',datos.codIncidenciaConcepto)
        editarValorConceptoIncidencia('nomIncidenciaConcepto',datos.nomIncidenciaConcepto)
        editarValorConceptoIncidencia('codProductoInterno',datos.codProductoInterno)
        editarValorConceptoIncidencia('codNivelCriticidad',datos.codNivelCriticidad)
        editarValorConceptoIncidencia('codNivel',datos.codNivel)
        editarValorConceptoIncidencia('desIncidenciaConcepto',datos.desIncidenciaConcepto)
    }

    const guardarConceptoIncidencia = async () => {
        const camposAValidar = ["codProductoInterno","codNivel", "nomIncidenciaConcepto"];
        const validar = camposAValidar.some(campo => conceptoIncidencia[campo] === "" || conceptoIncidencia[campo] === null || conceptoIncidencia[campo] === 0 || conceptoIncidencia[campo] === undefined);
        if(validar){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await registrarConceptoIncidencia()
        if(isValid)
        {
            await listarConceptosIncidencia()
            closeModalConcepto();
            return
        }
    }

    const abrirModalEliminar = async (data) => {
        editarValorEliminarConcepto('nomConcepto',data.nomIncidenciaConcepto);
        editarValorEliminarConcepto('codIncidenciaConcepto',data.codIncidenciaConcepto);
        openModalEliminar();
    }

    const cerrarModalEliminar = () => {
        setDatosEliminar(datosEliminarDefault);
        closeModalEliminar()
    }

    const guardarEliminarConcepto = async () => {
        const response = await eliminarConceptoIncidencia();
        if(response){
            await listarConceptosIncidencia()
            cerrarModalEliminar()
        }
    }

    useEffect(() => {
        document.title = "PGI | ConceptosIncidencia";
        listarProducto();
    },[])

    useEffect(() => {
        listarConceptosIncidencia(codigoProducto); 
    },[codigoProducto])

    return(
        <>
            <ContenedorParametros titulo='Concepto incidencia' tablaId={idTablaConceptoIncidencia}>
                    <BotonNuevo
                        onClick={iniciarDatosConcepto}
                    />
                    <div className="flex items-center gap-2">
                        <i className="fa fa-filter" data-for={'tipoProducto'} data-tip={'tipoProducto'}></i>
                        <Tooltip id={'tipoProducto'}>Tipo de producto</Tooltip>
                        <select
                            className={`${classNameInput}`}
                            onChange={(e) =>setCodigoProducto(Number(e.target.value))}
                        >
                            {
                                <option value={0}>--Todos--</option>
                            }
                            {
                                producto.length > 0 &&
                                producto.map(p => (
                                    <option value={p.codProductoInterno}>{p.nomProductoInterno}</option>
                                ))
                            }
                        </select>
                    </div>
            </ContenedorParametros>
            <div className=" containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla  w-[100%]">
                <table className="tableResponsive bg-zinc-800 ring-blue" id={idTablaConceptoIncidencia}>
                    <thead className="z-50">
                        <tr>
                            <th>N</th>
                            <th>CÓDIGO</th>
                            {
                                codigoProducto === 0 && 
                                <th className="text-left">PRODUCTO</th>
                            }
                            <th className="text-left">NOMBRE</th>
                            <th className="text-left max-w-[350px] w-[350px]">DESCRIPCIÓN</th>
                            <th>CALIFICACIÓN</th>
                            {/* <th>USUARIO</th> */}
                            {/* <th>FECHA HORA CREACIÓN</th> */}
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            conceptosIncidencia.length > 0 ?
                            conceptosIncidencia.map((concepto, indice) => {
                                return(
                                    <tr className="row">
                                        <td className="text-center">{indice + 1}</td>
                                        <td className="text-center">
                                            <label
                                                className="bg-blue-600 px-2 rounded inline-block w-[60px] text-center "
                                            >{concepto.codIncidenciaConcepto}</label>
                                        </td>
                                        {
                                            codigoProducto === 0 &&
                                            <td className="text-left">{concepto.nomProductoInterno}</td>
                                        }
                                        <td className="text-left">{concepto.nomIncidenciaConcepto}</td>
                                        <td className="text-left max-w-[350px] w-[350px]">
                                            <div className="w-[95%] whitespace-nowrap text-ellipsis overflow-hidden">{concepto.desIncidenciaConcepto}</div>
                                        </td>
                                        <td className="text-center">{concepto.nomNivel}</td>
                                        {/* <td className="text-center">{concepto.nomUsuario}</td> */}
                                        {/* <td className="text-center">{concepto.fechaHoraCreacion}</td> */}
                                        <td className="text-center">
                                            <button
                                                className="bg-blue-600 px-2 rounded"
                                                onClick={() => editarDatosConcepto(concepto)}
                                            >
                                                <i className="fa fa-edit"></i>
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                className="bg-red-600 px-2 rounded"
                                                onClick={() => abrirModalEliminar(concepto)}
                                            > 
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            }) 
                            : 
                            <tr><td colSpan={5} className="text-center">No hay información para mostrar...</td></tr>
                        }
                    </tbody>
                </table>
            </div>
            
            {/* Crear editar concepto de incidencia */}
            <Modal
                isOpen={isOpenModalConcepto}
                closeModal={closeModalConcepto}
                title={conceptoIncidencia.codIncidenciaConcepto === 0 ? 'Crear concepto' : `Editar concepto [ ${conceptoIncidencia.nomIncidenciaConcepto} ]` }
                textButtons={{ confirm: 'Guardar', denied:'Cerrar'}}
                action={guardarConceptoIncidencia}
                width={' w-[600px] '}
            >
                {
                    isOpenModalConcepto &&
                    <div className="grid grid-cols-[minmax(0,3fr)_minmax(0,7fr)] gap-1 w-full items-center">
                        <span className="">Nombre</span>
                        <input
                            className={`${classNameInput} `}
                            value={conceptoIncidencia.nomIncidenciaConcepto}
                            onChange={(e) => editarValorConceptoIncidencia('nomIncidenciaConcepto',e.target.value)}
                        />
                        <span className="">Tipo de Producto</span>
                        <select
                            className={`${classNameInput} `}
                            onChange={(e) => editarValorConceptoIncidencia('codProductoInterno',Number(e.target.value))}
                            value={conceptoIncidencia.codProductoInterno}
                        >
                            <option value={0}>-- Seleccione --</option>
                            {
                                producto.length > 0 &&
                                producto.map(p => (
                                    <option value={p.codProductoInterno}>{p.nomProductoInterno}</option>
                                ))
                            }
                        </select>
                        <span className="">Calificación</span>
                        <select
                            className={`${classNameInput} `}
                            onChange={(e) => editarValorConceptoIncidencia('codNivel',Number(e.target.value))}
                            value={conceptoIncidencia.codNivel}
                        >
                            {
                                <option value={0}>-- Seleccione --</option>
                            }
                            {
                                calificacion.map(data => (
                                    <option value={data.codNivel}>{data.nomNivel}</option>
                                ))
                            }
                        </select>
                        <span className="">Descripción</span>
                        <textarea
                            className={`${classNameInput}  resize-none`}
                            onChange={(e)=>editarValorConceptoIncidencia('desIncidenciaConcepto',e.target.value)}
                            value={conceptoIncidencia.desIncidenciaConcepto}
                        />
                    </div>
                }
            </Modal>

            {/* Eliminar concepto incidencia */}
            <Modal
                isOpen={isOpenModalEliminar}
                closeModal={cerrarModalEliminar}
                title={`[COD ${datosEliminar.codIncidenciaConcepto}] Eliminar concepto: ${datosEliminar.nomConcepto} `}
                validButton={{confirm: true, denied: true}}
                textButtons={{confirm: 'Guardar', denied: 'Cerrar',}}
                action={guardarEliminarConcepto}
            >
                {
                    isOpenModalEliminar &&
                    <section className="w-[450px] flex flex-col gap-2">
                        <label className="font-bold">Ingrese el motivo:</label>
                        <textarea
                            className={`${classNameInput} resize-none h-[80px]`}
                        />
                    </section>
                }
                
            </Modal>
        </>
    )
}